import { combineReducers } from 'redux';
import api from "./api";
import createEntitiesReducer from "./entities";
export function createRootReducer(customEntitiesInitialState) {
  const entities = createEntitiesReducer(customEntitiesInitialState);
  const rootReducer = combineReducers({
    api,
    entities: entities.reducer
  });
  return {
    rootReducer,
    entitiesInitState: entities.initState
  };
}